/**
 * Contact Page Script
 * @description Script usado apenas pelo template starter da pagina de contato
 */

import { initGlobalComponents } from '../modules/global-components.js';
import { initFormValidation } from '../form.js';

const initContactPage = () => {
    initGlobalComponents();
    initFormValidation('[data-validate-form]');
};

$(function() {
    initContactPage();
});

export default {
    init: initContactPage
};
